import http from "../../http-common";

const get = (data) => http.post("/Profile/FilterProfile", data);

const create = (data) => http.post("/Profile/InsertProfile", data);

const update = (data) => http.put("/Profile/UpdateProfile", data);

export default { get, create, update };
